import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/archive', label: 'Archive' },
];

const FOOTER_LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/shipping', label: 'Shipping' },
];

function Terms() {
  return (
    <div className="substack-site">
      <Header navItems={NAV_ITEMS} />

      <main className="legal-page">
        <div className="legal-container">
          <h1>Refund & Exchange Policy</h1>
          
          <p className="intro-text" style={{ fontSize: '20px', fontStyle: 'italic', marginBottom: '30px' }}>
            Policy Schmolicy. We want you to be happy, period. So this policy is more what you'd call 'guidelines' than actual rules.
          </p>
          
          <p>
            First off, if for whatever reason you are not entirely satisfied with your purchase, we're here to help. We want you to be completely satisfied with your purchase.
          </p>

          <section>
            <h2>Returns</h2>
            <p>
              If within 30 days you want to return an item for any reason, we will gladly exchange or credit any item that is returned in new and unused condition. We do not charge restocking or re-handling fees, however, we ask that you cover shipping costs for any returned items.
            </p>
          </section>

          <section>
            <h2>How to Return</h2>
            <p>To return your product, mail it to:</p>
            <p style={{ 
              background: '#f8f9fa', 
              padding: '20px', 
              borderRadius: '8px',
              marginTop: '15px'
            }}>
              <strong>the OBX Beach Bum</strong><br />
              103 Queen Anne Dr.<br />
              Edenton, NC 27932
            </p>
            <p>
              I recommend shipping all returns with a tracking number. It helps me process your return or exchange faster if you use the original box and packing material when shipping products back to us.
            </p>
          </section>

          <section>
            <h2>Processing Time</h2>
            <p>
              Please allow 10 to 12 business days for us to process your return or exchange. Your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment.
            </p>
          </section>

          <section>
            <h2>Questions?</h2>
            <p>
              Contact us at <a href="mailto:support@theobxbeachbum.com">support@theobxbeachbum.com</a> for questions related to refunds and returns.
            </p>
          </section>

          <div className="back-link">
            <Link to="/">← Back to Home</Link>
          </div>
        </div>
      </main>

      <Footer showLogo={false} legalLinks={FOOTER_LEGAL_LINKS} />
    </div>
  );
}

export default Terms;
